import axios from 'axios';

const instance = axios.create();

instance.defaults.xsrfCookieName = 'csrftoken'
instance.defaults.xsrfHeaderName = "X-CSRFTOKEN"

export default instance;